export const BEGINNER_ACTIVE_BUZZER_ACTION_OPTIONS: ReadonlyArray<[string, string]> = [
  ['ON', 'ON'],
  ['OFF', 'OFF'],
];

export const BEGINNER_NOTE_OPTIONS: ReadonlyArray<[string, string]> = [
  ['C', 'C'],
  ['D', 'D'],
  ['E', 'E'],
  ['F', 'F'],
  ['G', 'G'],
  ['A', 'A'],
  ['B', 'B'],
];

export const BEGINNER_OCTAVE_OPTIONS: ReadonlyArray<[string, string]> = [
  ['1', '1'],
  ['2', '2'],
  ['3', '3'],
  ['4', '4'],
  ['5', '5'],
  ['6', '6'],
  ['7', '7'],
  ['8', '8'],
];

export const BEGINNER_MELODY_OPTIONS: ReadonlyArray<[string, string]> = [
  ['Happy Birthday', 'HAPPY_BIRTHDAY'],
  ['Twinkle Twinkle', 'TWINKLE_TWINKLE'],
  ['Jingle Bells', 'JINGLE_BELLS'],
  ['Alarm', 'ALARM'],
  ['Door Bell', 'DOOR_BELL'],
];

export const BEGINNER_SPEAKER_SOUND_OPTIONS: ReadonlyArray<[string, string]> = [
  ['Bell', 'BELL'],
  ['Alarm', 'ALARM'],
  ['Clap', 'CLAP'],
  ['Dog', 'DOG'],
  ['Cat', 'CAT'],
  ['Drum', 'DRUM'],
  ['Custom', 'CUSTOM'],
];
